<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Branch Master <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Add Branch</h1>
            <div class="content-wrap">
                <form [formGroup]="branchForm">
                    <div class="row">
                        <div class="col-md-3">                            
                            <div class="form-group input-group-lg">
                                <label for="branchname" class="form-label">Branch Name<span class="color-red">*</span></label>
                                <input type="text" placeholder="Enter the branch name" formControlName="branchname"
                                    [(ngModel)]="branch.branchname" class="form-control form-input"
                                    id="branchname" [ngClass]="{'is-invalid': submitted && f.branchname.errors }" />
                                <div *ngIf="submitted && f.branchname.errors" class="invalid-feedback">
                                    <div *ngIf="f.branchname.errors.required">Branch Name is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="streamid" class="form-label">Stream<span class="color-red">*</span></label>
                                <select formControlName="streamid" class="form-control form-input"
                                [(ngModel)]="branch.streamid" >
                                    <option selected disabled value="undefined">Select your stream</option>
                                    <option *ngFor="let stream of streamDropDown" [ngValue]="stream.id">
                                        {{stream.streamName}}</option>
                                </select>
                                <div *ngIf="submitted && f.streamid.errors" class="invalid-feedback2">
                                    <div *ngIf="f.streamid.errors.required">Service Name is required</div>
                                </div>
                            </div>
                        </div>

                        

                    </div>
                    <button class="proceed-btn bg-theme" (click)="addBranch()">Submit</button>
                    <button class="proceed-btn" (click)="goBack()" >Cancel</button>
                </form>
            </div>
        </div>
    </div>
</div>
<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>